import createModel from "../createModel";
import { CodeValueLegacy } from "../common/CodeValueLegacy";

export const MutualFundsPaymentDetail = createModel("MutualFundsPaymentDetail", (json) => ({
    accountNumber: json.accountNumber,
    skQrCode: json.skQrCode,
    fund: CodeValueLegacy.fromServer(json.fund),
}));
